import styled from '@emotion/styled';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import mediaQuery from '@/lib/styling/mediaQuery';
import { IconButton, type IconButtonProps } from '@mui/material';
import { motion } from 'framer-motion';
import stripProps from '@/lib/utils/stripProps';

type StyledCloseButtonProps = IconButtonProps & {
  taskBoardOpen: boolean;
};

const StyledCloseButton = styled(
  motion.create(stripProps(IconButton, 'taskBoardOpen')),
)<StyledCloseButtonProps>(
  ({ theme, taskBoardOpen }) => ({
    position: 'absolute',
    top: 0,
    left: 102,
    // This additional forced-white override is necessary for the high-contrast
    // version of the light theme
    color: 'white !important',
    transition: theme.transitions.create('all'),
    ':hover': {
      backgroundColor: 'rgba(255, 255, 255, .1)',
    },
    [mediaQuery(960)]: {
      left: 32,
    },
    [mediaQuery(768)]: {
      top: 8,
      left: taskBoardOpen ? 8 : undefined,
    },
    [mediaQuery(560)]: {
      left: 8,
    },
  }),
  addHighContrastStyles({
    backgroundColor: 'black',
    border: `2px solid white`,
    ':hover, :focus': {
      backgroundColor: 'black',
      transform: 'scale(1.05) !important',
    },
  }),
);

export default StyledCloseButton;
